import DetailButton from "../DetectionDetailPopup/DetailButton";

// Key/value details of a process, shared by the Details tab and the process popup
const ProcessDetails = ({
  process,
  parent,
  detection,
  suspicious,
  reasons = [],
  onSelectParent,
  onOpenDetection,
}) => {
  const details = [
    ["Process", process.name],
    ["PID", process.pid],
    [
      "Parent",
      parent ? (
        <button
          type="button"
          className="thunter-process-tree__link"
          onClick={() => onSelectParent(parent.pid)}>
          {parent.name} ({parent.pid})
        </button>
      ) : (
        `<Non-existent Process> (${process.ppid ?? "-"})`
      ),
    ],
    ["User", process.user],
    ["Path", process.path],
    ["Command Line", process.cmdline],
    ["MD5", process.md5],
    ["Threads", process.threads],
    ["Description", process.description],
    ["Company", process.company],
    ["Signature", detection?.signature_status || suspicious?.signature_status],
    ["Signer", detection?.signer],
    ["Detection", detection?.reason],
    ["Flag Reason", reasons.join("\n")],
  ];

  return (
    <div className="thunter-process-tree__details">
      {details
        .filter(([, value]) => value !== null && value !== undefined && value !== "")
        .map(([label, value]) => (
          <div key={label} className="thunter-process-tree__detail">
            <span className="thunter-process-tree__detail-label">{label}</span>
            <span className="thunter-process-tree__detail-value">{value}</span>
          </div>
        ))}
      {detection ? (
        <div className="thunter-process-tree__detail">
          <span className="thunter-process-tree__detail-label">Detection Details</span>
          <span className="thunter-process-tree__detail-value">
            <DetailButton
              title="Show detection details"
              onClick={() => onOpenDetection(detection)}
            />
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default ProcessDetails;
